export default {
  setItem(name, data) {
    const lsPrefix = 'cafam_';
    return localStorage.setItem(`${lsPrefix}${name}`, JSON.stringify(data));
  },
  removeItem(name) {
    const lsPrefix = 'cafam_';
    return localStorage.removeItem(`${lsPrefix}${name}`);
  },
  getItem(name) {
    const lsPrefix = 'cafam_';
    let value = localStorage.getItem(`${lsPrefix}${name}`);
    try {
      value = JSON.parse(value);
      // eslint-disable-next-line no-empty
    } catch (error) {}
    return value;
  }
};
